import { render, staticRenderFns } from "./AppChatMessage.vue?vue&type=template&id=dc686b64&"
import script from "./AppChatMessage.vue?vue&type=script&lang=ts&"
export * from "./AppChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./AppChatMessage.vue?vue&type=style&index=0&id=dc686b64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports